import React from 'react';
import { Grid, Card, CardContent, Typography, Avatar } from '@mui/material';
import { PermissionLevel } from '../../../../../generated/data-contracts';
import { permissionConfig } from '../constants/entityConfig';

interface PermissionSelectorProps {
  selectedLevel: PermissionLevel;
  onLevelChange: (level: PermissionLevel) => void;
}

export const PermissionSelector: React.FC<PermissionSelectorProps> = ({
  selectedLevel,
  onLevelChange,
}) => {
  return (
    <Grid container spacing={2}>
      {Object.entries(permissionConfig).map(([level, permConfig]) => (
        <Grid item xs={4} key={level}>
          <Card
            onClick={() => onLevelChange(level as PermissionLevel)}
            sx={{
              cursor: 'pointer',
              border:
                selectedLevel === level
                  ? `2px solid ${permConfig.color}`
                  : `1px solid ${permConfig.color}30`,
              bgcolor:
                selectedLevel === level
                  ? permConfig.bgColor
                  : 'background.paper',
              transition: 'all 0.3s ease',
              height: '100%',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: 3,
                bgcolor: permConfig.bgColor,
              },
            }}
          >
            <CardContent sx={{ textAlign: 'center', py: 2 }}>
              <Avatar
                sx={{
                  color: permConfig.color,
                  margin: '0 auto 12px',
                  width: 48,
                  height: 48,
                }}
              >
                {permConfig.icon}
              </Avatar>
              <Typography
                variant='subtitle2'
                sx={{ fontWeight: 'bold', mb: 1 }}
              >
                {permConfig.label}
              </Typography>
              <Typography variant='caption' color='textSecondary'>
                {permConfig.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
